export default __webpack_public_path__ + "static/media/set.d7eee50a.svg";